import { PLAYBOOK_TYPES } from 'layouts/OnboardingPlaybookPickBotStep'

const getRoot = state => state.playbook

export const getNewsletterPlaybookId = state =>  getRoot(state).newsletterPlaybookId
export const getDemoRequestPlaybookId = state =>  getRoot(state).demoRequestPlaybookId

export const getNewsletterInteractionId = state =>  getRoot(state).newsletterInteractionId
export const getDemoRequestInteractionId = state =>  getRoot(state).demoRequestInteractionId

export const getLandingPageSettings = state => getRoot(state).CLPSettings || {}
export const getLandingPageSubdomain = state => getRoot(state).CLPSubdomain
export const getLandingPageCname = state => getRoot(state).CLPCname
export const getHandle = state => getRoot(state).handle

export const getDemoRequestProductName = state => getRoot(state).demoRequestProductName
export const getDemoRequestValueProp = state => getRoot(state).demoRequestValueProp
export const getDemoRequestIndustry = state => getRoot(state).demoRequestIndustry

export const getPlaybookType = state => getRoot(state).playbookType

export const getCompanyName = state => getRoot(state).companyName
export const getCompanyUrl = state => getRoot(state).companyUrl
export const getCompanyLogoUrl = state => getRoot(state).companyLogoUrl

export const getIsWidgetVerified = state => getRoot(state).isWidgetVerified

export const getOnboardingPlaybookId = state => {
  const playbookType = getPlaybookType(state)
  if ( playbookType === PLAYBOOK_TYPES.DEMO_REQUEST ) {
    return getDemoRequestPlaybookId(state)
  }
  else if ( playbookType === PLAYBOOK_TYPES.NEWSLETTER ) {
    return getNewsletterPlaybookId(state)
  }
}

export const getOnboardingInteractionId = state => {
  const playbookType = getPlaybookType(state)
  if ( playbookType === PLAYBOOK_TYPES.DEMO_REQUEST ) {
    return getDemoRequestInteractionId(state)
  }
  else if ( playbookType === PLAYBOOK_TYPES.NEWSLETTER ) {
    return getNewsletterInteractionId(state)
  }
}


// WEBPACK FOOTER //
// ./src/modules/playbook/selectors.js